module.exports = __webpack_public_path__ + "img/ch-gr.3a23ad8e.svg";